import * as React from 'react';
import { connect } from 'react-redux';
import _ from 'lodash';
import { makeTranslator, translateFunc } from '../../utilities/translations';
import {
  DeliveryDefField,
  ForskarBeställningFieldStates,
  DeliveryDefinition,
  ResearchOrderModel,
  researchOrderFiles,
  ResearchOrderStore,
} from '../../models';
import {
  getErrorMessageByFieldName,
  getErrorMessageByFieldNameAfterHitSummary,
  mandatoryIfNotOnlyDeceased,
  allScopedResearchOrderFiles2SelectBoxOptions,
} from '../../utilities/helpers';
import { TextInput } from 'sos-common/js/components/FormControls/TextInput';
import { RadioButtonGroup } from 'sos-common/js/components/FormControls/RadioButtonGroup';
import { RadioButton } from 'sos-common/js/components/FormControls/RadioButton';
import { SelectBox } from 'sos-common/js/components/FormControls/SelectBox';
import { CheckBox } from 'sos-common/js/components/FormControls/CheckBox';
import { CheckBoxGroup } from 'sos-common/js/components/FormControls/CheckBoxGroup';
import { InputError } from 'sos-common/js/components/InputError/InputError';
import { Tooltip } from 'sos-common/js/components/Tooltip/Tooltip';
import { FormFieldProps } from 'sos-common/js/commonTypes/formField.types';
import { ValidationResult } from 'sos-common/js/commonTypes/validation.types';
import { hashCode } from 'sos-common/js/utils/hash';
export interface DeliveryDefinitionProps extends FormFieldProps<DeliveryDefinition> {
  fieldName: string;
  onChange(field: DeliveryDefField): void;
  Translate?: translateFunc;
  files: researchOrderFiles;
  purposeForSaveSerialNoOptions: string[];
  validationResults: ValidationResult[];
  fullValidationResults?: ValidationResult[];
  hasHitSummary?: boolean;
  researchOrder: ResearchOrderModel;
}
export interface DeliveryDefinitionState extends DeliveryDefField {
  touchedMap: Map<string, boolean>;
}

let HowToDeliverDataOptions = {
  Number: 'Med löpnummer',
  NumberSaved: 'Med löpnummer där en löpnummernyckel sparas',
  PNumber: 'Med personnummer',
};

class DeliveryDefinitionInput extends React.Component<DeliveryDefinitionProps, DeliveryDefinitionState> {
  private _errorId: string;

  static defaultProps = {
    onChange: () => {},
  };

  constructor(props: any) {
    super(props);
    const { fieldName, value } = props;

    this._errorId = hashCode(props.id || props.fieldName, 'error');

    this.state = {
      isTouched: true,
      errorMessage: '',
      value,
      fieldName,
      touchedMap: new Map(),
    } as DeliveryDefinitionState;
  }

  private get _errorMessage(): string | undefined {
    let { errorMessage } = this.state;
    if (!errorMessage && this.props.errorMessage) {
      errorMessage = this.props.errorMessage;
    }

    return errorMessage;
  }

  onChangeField = (field: ForskarBeställningFieldStates) => {
    const newState = { ...this.state };
    const deliveryDef = newState.value;

    // Set touched for this field to true
    newState.touchedMap.set(field.fieldName, true);

    // Reset data if we change the outer radio choices
    if (field.fieldName === 'CurrentResearchOrder.DeliveryDefinition.HowToDeliverData') {
      deliveryDef.EthicsDecisionKey.FileId = null;
      deliveryDef.EthicsDecisionKey.Page = null;
      deliveryDef.IntentToContactCitizens = null;
      deliveryDef.MotivationPersonalDataNeeded = '';
      deliveryDef.PurposeForSaveSerialNo = [];
      newState.touchedMap = new Map();
    }

    const path = field.fieldName.replace('CurrentResearchOrder.DeliveryDefinition.', '').split('.');
    this.setState(
      (state) => {
        _.set(deliveryDef, path, field.value);
        newState.value = { ...deliveryDef };
        return newState;
      },
      () => {
        this.props.onChange(this.state);
      }
    );
  };

  renderWithSavedSection = () => {
    const {
      Translate,
      purposeForSaveSerialNoOptions,
      files,
      validationResults,
      fullValidationResults,
      researchOrder,
      hasHitSummary,
    } = this.props;
    const { HowToDeliverData } = this.props.value;
    const DeliveryDefinition = this.state.value;
    return (
      <div className="indent">
        <p>{Translate('/orderFormPage/FyllISidaEtikMotiveras')}</p>
        <div className="row">
          <div className="col-md-6 form-group-small">
            <SelectBox
              label={
                mandatoryIfNotOnlyDeceased(researchOrder)
                  ? Translate('/orderformpage/ChooseFileWithStar')
                  : Translate('/orderformpage/ChooseFile')
              }
              fieldName="CurrentResearchOrder.DeliveryDefinition.EthicsDecisionKey.FileId"
              options={allScopedResearchOrderFiles2SelectBoxOptions(files)}
              value={_.get(DeliveryDefinition, 'EthicsDecisionKey.FileId')}
              onChange={this.onChangeField}
              errorMessage={
                this.state.touchedMap.get('CurrentResearchOrder.DeliveryDefinition.EthicsDecisionKey.FileId') ||
                hasHitSummary
                  ? getErrorMessageByFieldName(
                      fullValidationResults,
                      'CurrentResearchOrder.DeliveryDefinition.EthicsDecisionKey.FileId'
                    )
                  : ''
              }
              isRequired={mandatoryIfNotOnlyDeceased(researchOrder)}
            />
          </div>
          <div className="col-md-6 form-group-small">
            <TextInput
              label={
                mandatoryIfNotOnlyDeceased(researchOrder)
                  ? Translate('/orderformpage/SidaAvsnitt')
                  : Translate('/orderformpage/SidaAvsnittNoStar')
              }
              fieldName="CurrentResearchOrder.DeliveryDefinition.EthicsDecisionKey.Page"
              placeholder={Translate('/orderformpage/SidaAvsnittNoStar')}
              maxLength={50}
              value={_.get(DeliveryDefinition, 'EthicsDecisionKey.Page')}
              onChange={this.onChangeField}
              errorMessage={
                this.state.touchedMap.get('CurrentResearchOrder.DeliveryDefinition.EthicsDecisionKey.Page') ||
                hasHitSummary
                  ? getErrorMessageByFieldName(
                      fullValidationResults,
                      'CurrentResearchOrder.DeliveryDefinition.EthicsDecisionKey.Page'
                    )
                  : ''
              }
              isRequired={mandatoryIfNotOnlyDeceased(researchOrder)}
            />
          </div>
          <div className="col-md-12">
            <div className="like-a-label">{Translate('/orderformpage/VarforSkaNyckelSparas')}</div>
            <CheckBoxGroup
              fieldName="CurrentResearchOrder.DeliveryDefinition.PurposeForSaveSerialNo"
              value={_.get(DeliveryDefinition, 'PurposeForSaveSerialNo', [] as string[])}
              onChange={this.onChangeField}
              errorMessage={
                this.state.touchedMap.get('CurrentResearchOrder.DeliveryDefinition.PurposeForSaveSerialNo') ||
                hasHitSummary
                  ? getErrorMessageByFieldName(
                      fullValidationResults,
                      'CurrentResearchOrder.DeliveryDefinition.PurposeForSaveSerialNo'
                    )
                  : ''
              }>
              {purposeForSaveSerialNoOptions.map((purposeItem) => (
                <CheckBox key={purposeItem} stringValue={purposeItem} label={purposeItem} />
              ))}
            </CheckBoxGroup>
          </div>
          <br />
        </div>
      </div>
    );
  };

  renderWithPNumberSection = () => {
    const { Translate, files, validationResults, fullValidationResults, hasHitSummary, researchOrder } = this.props;
    const DeliveryDefinition = this.state.value;
    return (
      <div className="indent">
        <br />
        <p>{Translate('/orderFormPage/FyllISidaHurPersonnummerBahandlas')}</p>
        <div className="row form-group-small">
          <div className="col-md-6 form-group-small">
            <SelectBox
              label={
                mandatoryIfNotOnlyDeceased(researchOrder)
                  ? Translate('/orderformpage/ChooseFileWithStar')
                  : Translate('/orderformpage/ChooseFile')
              }
              options={allScopedResearchOrderFiles2SelectBoxOptions(files)}
              value={_.get(DeliveryDefinition, 'EthicsDecisionKey.FileId')}
              fieldName="CurrentResearchOrder.DeliveryDefinition.EthicsDecisionKey.FileId"
              errorMessage={
                this.state.touchedMap.get('CurrentResearchOrder.DeliveryDefinition.EthicsDecisionKey.FileId') ||
                hasHitSummary
                  ? getErrorMessageByFieldName(
                      fullValidationResults,
                      'CurrentResearchOrder.DeliveryDefinition.EthicsDecisionKey.FileId'
                    )
                  : ''
              }
              onChange={this.onChangeField}
              isRequired={mandatoryIfNotOnlyDeceased(researchOrder)}
            />
          </div>
          <div className="col-md-6 form-group-small">
            <TextInput
              placeholder={Translate('/orderformpage/SidaAvsnittNoStar')}
              value={_.get(DeliveryDefinition, 'EthicsDecisionKey.Page')}
              onChange={this.onChangeField}
              maxLength={160}
              fieldName="CurrentResearchOrder.DeliveryDefinition.EthicsDecisionKey.Page"
              isRequired={mandatoryIfNotOnlyDeceased(researchOrder)}
              errorMessage={
                this.state.touchedMap.get('CurrentResearchOrder.DeliveryDefinition.EthicsDecisionKey.Page') ||
                hasHitSummary
                  ? getErrorMessageByFieldName(
                      fullValidationResults,
                      'CurrentResearchOrder.DeliveryDefinition.EthicsDecisionKey.Page'
                    )
                  : ''
              }
              label={
                mandatoryIfNotOnlyDeceased(researchOrder)
                  ? Translate('/orderformpage/SidaAvsnitt')
                  : Translate('/orderformpage/SidaAvsnittNoStar')
              }
            />
          </div>
          <div className="col-md-12 form-group-small">
            {/* <label>{Translate('/orderformpage/MotiveraVarfor')}</label> */}
            <TextInput
              multiline
              maxLength={4000}
              classNames="height240px"
              placeholder={Translate('/orderformpage/Motivering')}
              value={_.get(DeliveryDefinition, 'MotivationPersonalDataNeeded')}
              fieldName="CurrentResearchOrder.DeliveryDefinition.MotivationPersonalDataNeeded"
              errorMessage={
                this.state.touchedMap.get('CurrentResearchOrder.DeliveryDefinition.MotivationPersonalDataNeeded') ||
                hasHitSummary
                  ? getErrorMessageByFieldName(
                      fullValidationResults,
                      'CurrentResearchOrder.DeliveryDefinition.MotivationPersonalDataNeeded'
                    )
                  : ''
              }
              onChange={this.onChangeField}
              label={Translate('/orderformpage/MotiveraVarfor')}
              isRequired={true}
            />
          </div>
        </div>
        <div role="group" aria-labelledby="AvserKontaktaPersonerLabel">
          <div id="AvserKontaktaPersonerLabel" className="like-a-label">
            {Translate('/orderformpage/AvserKontaktaPersoner')}
          </div>
          <RadioButtonGroup
            value={_.get(DeliveryDefinition, 'IntentToContactCitizens')}
            fieldName="CurrentResearchOrder.DeliveryDefinition.IntentToContactCitizens"
            errorMessage={getErrorMessageByFieldNameAfterHitSummary(
              validationResults,
              'DeliveryDefinition.IntentToContactCitizens',
              hasHitSummary
            )}
            onChange={this.onChangeField}
            isRequired={true}>
            <RadioButton value={true} label={Translate('/global/yes')} />
            <RadioButton value={false} label={Translate('/global/no')} />
          </RadioButtonGroup>
        </div>
      </div>
    );
  };

  public render() {
    const { Translate } = this.props;
    const { HowToDeliverData } = this.state.value;
    const errorMessage = this._errorMessage;
    const errorAriaAttr = errorMessage ? { 'aria-invalid': true, 'aria-describedby': this._errorId } : null;
    return (
      <div role="group" aria-labelledby="HurLamnaUtDataLabel">
        <h2 id="HurLamnaUtDataLabel" className="inlineblock">
          {Translate('/orderFormPage/HurLamnaUtData')}
        </h2>
        <Tooltip text={Translate('/InfobubblorForskarBestallning/PaVilketSattSkaViLämnaUtDataValjEttAvAlternativen')} />
        <br />
        <RadioButton<string>
          value={HowToDeliverDataOptions.Number}
          checked={HowToDeliverData === HowToDeliverDataOptions.Number}
          onChange={this.onChangeField}
          fieldName="CurrentResearchOrder.DeliveryDefinition.HowToDeliverData"
          label={Translate('/orderFormPage/MedLopnummer')}
          errorAriaAttributes={errorAriaAttr}
          isRequired={true}
        />

        <RadioButton<string>
          value={HowToDeliverDataOptions.NumberSaved}
          checked={HowToDeliverData === HowToDeliverDataOptions.NumberSaved}
          onChange={this.onChangeField}
          fieldName="CurrentResearchOrder.DeliveryDefinition.HowToDeliverData"
          label={Translate('/orderFormPage/MedLopnummerNyckelSparas')}
          errorAriaAttributes={errorAriaAttr}
          isRequired={true}
        />

        {HowToDeliverData === HowToDeliverDataOptions.NumberSaved && this.renderWithSavedSection()}
        <RadioButton<string>
          fieldName="CurrentResearchOrder.DeliveryDefinition.HowToDeliverData"
          onChange={this.onChangeField}
          value={HowToDeliverDataOptions.PNumber}
          checked={HowToDeliverData === HowToDeliverDataOptions.PNumber}
          label={Translate('/orderFormPage/MedPersonnummer')}
          errorAriaAttributes={errorAriaAttr}
          isRequired={true}
        />
        {HowToDeliverData === HowToDeliverDataOptions.PNumber && this.renderWithPNumberSection()}
        {errorMessage && <InputError id={this._errorId} errorText={errorMessage} />}
      </div>
    );
  }
}

const mapState2Props = (state: ResearchOrderStore) => {
  return {
    Translate: makeTranslator(state.globals.translations),
    files: state.files,
    purposeForSaveSerialNoOptions: state.globals.purposeForSaveSerialNoOptions,
    value: state.formModel.DeliveryDefinition,
    validationResults: state.validationState.validationResults,
    fullValidationResults: state.validationState.fullValidationResults,
    researchOrder: state.formModel,
  };
};

export default connect(mapState2Props)(DeliveryDefinitionInput);
